import PropTypes from 'prop-types'

const InspectionsToolbarItem = ({ leftContent, rightContent }) => (
  <div className="ctp-internal-inspections-toolbar">
    <div className="ctp-internal-inspections-toolbar__side">{leftContent}</div>
    <div className="ctp-internal-inspections-toolbar__side">{rightContent}</div>
  </div>
)

InspectionsToolbarItem.propTypes = {
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
}

export default InspectionsToolbarItem
